module.exports = __webpack_public_path__ + "static/commute-times-79c240fc3df6e9300fa4319302f7a226.png";